module.exports = __webpack_public_path__ + "media/images/banners/bg6-15740c95653bd8cff0266f842bb78936.png";